import React from 'react'
import { PageHeader as AntPageHeader, Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import userManager from '../../business/oidc/userManager'
import { navigate } from '@reach/router';
import BotSelector from './botSelector/BotSelector';
import CSS from 'csstype';

type PageHeaderProps = {
    title?: string
    subTitle?: string
    onBackDestination?: string
    style?: CSS.Properties
    showBotSelector?: boolean
    onBotSelect: (id: string) => void
}

export const PageHeader: React.FunctionComponent<PageHeaderProps> = ({
    title,
    subTitle,
    onBackDestination,
    style,
    showBotSelector,
    onBotSelect
}) => {
    const logout = () => {
        userManager.signoutRedirect();
    }

    return (
        <AntPageHeader
            style={style}
            className="site-page-header"
            onBack={
                onBackDestination
                    ? () => navigate(onBackDestination)
                    : undefined
            }
            title={title}
            subTitle={subTitle}
            extra={[
                showBotSelector? <BotSelector onBotSelect={onBotSelect}/> : null,
                <Button
                    type="primary"
                    shape="circle"
                    onClick={logout}
                    icon={<LogoutOutlined />}
                />
            ]}
        />
    )
}

export default PageHeader
